<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-app>
    <div
      class="d-flex"
      style="height: 100vh"
    >
      <template v-if="$vuetify.breakpoint.lgAndUp">
        <div
          class="text-center hidden-sm-and-down d-flex align-center justify-center "
          style="width: 50%;height:100%;background-color: #f9f9f1"
        >
          <primary-logo-display />
        </div>
      </template>
      <div
        :style="{width:!$vuetify.breakpoint.lgAndUp?'100%':'50%'}"
        class="grey lighten-4"
      >
        <router-view />
      </div>
    </div>
  </v-app>
</template>

<script>

import PrimaryLogoDisplay from '@/views/widget/uiComponent/PrimaryLogoDisplay.vue'

export default {
  name: 'SaaSIndex',
  components: { PrimaryLogoDisplay },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
